"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = void 0;
var defaultConfig = {
  hideProgressBar: false,
  openLinksInNewTab: true,
  position: "top-right",
  theme: {},
  transition: "slide"
};
exports.defaultConfig = defaultConfig;